// src/components/OurApproach/OurApproach.jsx
import React, { useState } from "react";
import "./OurApproach.css";

export default function OurApproach() {
  const [active, setActive] = useState(1);

  const steps = [
    {
      id: 1,
      title: "Recherche & Plannification",
      content:
        "Analyse approfondie des besoins du client, identification des objectifs et contraintes du projet. Réalisation d'une étude de marché complète pour comprendre l'environnement concurrentiel et les attentes des utilisateurs. Élaboration d'une stratégie claire, planification des ressources et définition d'un cahier des charges détaillé pour garantir la réussite du projet dès le départ."
    },
    {
      id: 2,
      title: "Conception & Développement Web",
      content:
        "Création d'une expérience utilisateur (UI/UX) moderne et intuitive, en tenant compte des meilleures pratiques de design. Développement agile du site ou de l'application web, avec des itérations régulières pour intégrer les retours du client. Intégration de fonctionnalités sur mesure, optimisation du code et respect des standards de qualité pour assurer robustesse et évolutivité."
    },
    {
      id: 3,
      title: "Test & Déploiement",
      content:
        "Réalisation de tests approfondis (fonctionnels, unitaires, d'intégration et de performance) pour garantir la fiabilité et la sécurité de la solution. Optimisation des performances, correction des bugs et validation finale avec le client. Mise en ligne sécurisée sur l'environnement de production, en assurant une transition fluide et sans interruption de service."
    },
    {
      id: 4,
      title: "Support & Évolution",
      content:
        "Accompagnement continu après le lancement, avec un support technique réactif pour résoudre les éventuels problèmes. Mise en place de mises à jour régulières pour garantir la sécurité et la compatibilité. Proposition d'améliorations et d'évolutions fonctionnelles pour faire grandir la solution en fonction des besoins et des retours des utilisateurs."
    },
  ];

  return (
    <section className="our-approach">
      <h2>Notre Approche</h2>
      <div className="approach-container">
        <div className="approach-steps">
          {steps.map((step) => (
            <div
              key={step.id}
              className={`approach-step ${active === step.id ? "active" : ""}`}
              onClick={() => setActive(step.id)}
            >
              {step.title}
            </div>
          ))}
        </div>
        <div className="approach-content">
          <p>{steps.find((s) => s.id === active).content}</p>
        </div>
      </div>
    </section>
  );
}
